import Client from "./Client";
// import RequestList from "./RequestList";

const FaxesService = {
    url: 'admin/fax-channels',
    getDefault(){
        return {
            id : undefined,
            name : undefined,
            class_name : undefined,
            data : {},
            description : undefined,
            created_at : undefined,
            updated_at : undefined,
        }
    },
    getSimotelDataDefault(){
        return {
            host : undefined,
            username : undefined,
            password : undefined,
            trunk_name : undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async create(model) {
        return await Client.post(`${this.url}`, model);
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async update(model) {
        return await Client.post(`${this.url}/${model.id}`, model);
    }
}

export default FaxesService